import { EnvironmentType } from '@fleet-beat/core';

export interface Environment {
  type: EnvironmentType;
  identityApiUrl: string;
  tenantsApiUrl: string;
  tenantsHubUrl: string;
  assetsApiUrl: string;
  assetsHubUrl: string;
  mapsApiUrl: string;
  mapsHubUrl: string;
  metricsApiUrl: string;
  mapboxAccessToken: string;
  // eslint-disable-next-line no-comments/disallowComments
  // -----new API
  apiEndpoint: string;
  messagingHubUrl: string;
  stripeKey: string;
}
